module.exports = __webpack_public_path__ + "static/media/headshot2_v2.ec0b6139.gif";